import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { Element } from 'react-scroll';
import { Field } from 'redux-form';
import { propBool, propShape, propStr, } from '../../../../../../helpers/custom-prop-types';
import { validateSolutionImage } from '../../../../../../validate/solution';
import SolutionBaseFileImage from '../Base/SolutionBaseFileImage';
import InputTitle from '../InputTitle';
const SolutionImageUpload = (props) => {
    const { formFields, isRequired, label, name, tip } = props;
    const pdfFileUrl = formFields.values ? formFields.values.thumbnailUrl : '';
    return (_jsxs("div", Object.assign({ className: 'form form-solution' }, { children: [_jsx(InputTitle, { isRequired: isRequired, label: label, tip: tip }), _jsx(Element, Object.assign({ className: 'form-solution-upload', name: `${name}_view` }, { children: _jsx(Field, { accept: 'image/*', component: SolutionBaseFileImage, defaultFileUrl: pdfFileUrl, name: name, submitButtonClassName: 'btn btn-secondary small', validate: validateSolutionImage }) }))] })));
};
SolutionImageUpload.propTypes = {
    formFields: propShape().isRequired,
    isRequired: propBool(),
    label: propStr().isRequired,
    name: propStr().isRequired,
    tip: propStr(),
};
SolutionImageUpload.defaultProps = {
    isRequired: false,
    tip: '',
};
export default SolutionImageUpload;
